export default __webpack_public_path__ + "static/media/Invisible-Aligners.2af0271f.png";